<template>
  <div
    class="loader"
    :style="{
      width: makeSmall ? '24px' : '78px',
      height: makeSmall ? '24px' : '78px'
    }"
  >
    <svg class="circular" viewBox="25 25 50 50">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="5"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CircularLoader',
  props: {
    makeSmall: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.loader {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circular {
  width: 80%;
  height: 80%;
  animation: rotate 2s linear infinite;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    var(--white-color) 40%,
    var(--case-btn-border-color) 40%
  );
}

.path {
  stroke: var(--accent-color);
  stroke-width: 10;
  stroke-linecap: butt;
  fill: none;
  animation: dash 2s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0%, 10% {
    stroke-dasharray: 10, 126;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 113, 126;
    stroke-dashoffset: 0;
  }
  60% {
    stroke-dasharray: 113, 126;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dasharray: 10, 126;
    stroke-dashoffset: 0;
  }
}
</style>
